import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;

const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios.get(`${API_URL}/api/auth/consent-notices`).then((r) => { cache = r.data; return cache; }).catch(() => ({ active: false, notices: {} }));
  }
  return inflight;
};

export const useConsentNotices = () => {
  const [data, setData] = useState(cache);
  useEffect(() => { let on = true; load().then((d) => { if (on) setData(d); }); return () => { on = false; }; }, []);
  return data;
};

// Renders the lawyer's wording (slot / sub-text) only when legal docs are published (active); otherwise today's wording (children) exactly.
export const ConsentNotice = ({ slot, sub, children, className, testId }) => {
  const data = useConsentNotices();
  const notice = data?.active ? data.notices?.[slot] : null;
  const text = notice ? (sub ? notice.texts?.[sub] : notice.text) : null;
  if (!text) return children;
  return <span className={className} data-testid={testId || `consent-notice-${slot}${sub ? `-${sub}` : ''}`} data-notice-version={notice.version}>{text}</span>;
};
